import * as entities from './entities';

const reducers = Object.keys(entities).reduce((all, entityKey) => {
    all[entityKey] = entities[entityKey].reducer();
    return all;
}, {});

export default reducers;
